module.exports = new __parcel__URL__("add_stardust_rect.0a185349.png").toString();